import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BDataGrid } from '../common/dataGrid/BDataGrid';
import { TransactionRowTemplate } from './TransactionRowTemplate';
import { TransactionRowTemplateMobile } from './TransactionRowTemplateMobile';
import SpendingsStore from '../../stores/SpendingsStore';
import SpendingsActionCreator from '../../actions/SpendingsActionCreator';
import BrowserUtils from '../../utils/BrowserUtils';

const columnMeta = [
  {
    columnName: 'date',
    order: 1,
    locked: false,
    visible: true,
    displayName: 'Date',
    sortable: true,
    sortDirectionCycle: ['desc', 'asc'],
    customComponent: TransactionRowTemplate,
    cssClassName: 'column-date',
  },
  {
    columnName: 'description',
    order: 2,
    locked: false,
    visible: true,
    displayName: 'Description',
    sortable: true,
    sortDirectionCycle: ['desc', 'asc'],
    customComponent: TransactionRowTemplate,
    cssClassName: 'column-desc',
  },
  {
    columnName: 'type',
    order: 3,
    locked: false,
    visible: true,
    displayName: 'Type',
    sortable: true,
    customComponent: TransactionRowTemplate,
    cssClassName: 'column-type',
  },
  {
    columnName: 'tag',
    order: 4,
    locked: false,
    visible: true,
    displayName: 'Tag',
    sortable: false,
    customComponent: TransactionRowTemplate,
    cssClassName: 'column-tags',
  },
  {
    columnName: 'amount',
    order: 5,
    locked: false,
    visible: true,
    displayName: 'Amount',
    sortable: true,
    customComponent: TransactionRowTemplate,
    cssClassName: 'column-amount',
  },
  {
    columnName: 'account',
    order: 6,
    locked: false,
    visible: true,
    displayName: 'Account',
    sortable: false,
    customComponent: TransactionRowTemplate,
    cssClassName: 'column-account',
  },
];

function getSortField(sortName) {
  switch (sortName) {
    case 'date': {
      return 'details.when';
    }
    case 'description': {
      return 'details.narrative.medium.raw';
    }
    case 'type': {
      return 'details.type';
    }
    case 'amount': {
      return 'details.amount.value';
    }
    default: {
      return sortName;
    }
  }
}

class TransactionScreenDataGrid extends Component {
  constructor(props) {
    super(props);
    this.onPageChange = this.onPageChange.bind(this);
    this.onSortChange = this.onSortChange.bind(this);

    this.state = {
      transactionDetailsData: SpendingsStore.getTransactionDetails(),
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.onRowClick !== this.props.onRowClick ||
      prevProps.rowClickIndex !== this.props.rowClickIndex ||
      prevProps.rowCustomClass !== this.props.rowCustomClass ||
      prevProps.content !== this.props.content
    ) {
      this.setState({
        transactionDetailsData: SpendingsStore.getTransactionDetails(),
      });
    }
  }

  onPageChange() {
    SpendingsActionCreator.getTransactionDetailsOnNext();
  }

  onSortChange(sortName, sort) {
    SpendingsActionCreator.getTransactionDetailsOnSort({
      order: sort,
      sort_field: getSortField(sortName),
    });
  }

  render() {
    const { tableData, totalData } = this.state.transactionDetailsData;
    const { content } = this.props;

    const hasMoreData =
      tableData.length >= 25 || tableData.length !== totalData;
    const isFooterEnabled =
      tableData.length < 25 || tableData.length === totalData;

    return (
      <div>
        {BrowserUtils.isMobileView() ? (
          <div>
            <div className="transaction-screen-list">
              {tableData.map((data, index) => (
                <TransactionRowTemplateMobile
                  rowData={data}
                  key={`transactionDataGridMobileRows_TransactionRowTemplateMobile_${index}`}
                />
              ))}
            </div>
            <div className="transaction-list-show-more-container">
              {isFooterEnabled && (
                <button className="callout transaction-list-thats-all">
                  That's all we can find. Try changing your date range?
                </button>
              )}
              {!isFooterEnabled && hasMoreData && (
                <button
                  className="button transaction-list-show-more"
                  onClick={this.onPageChange}
                >
                  Show more
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className="oldTable spendings-grid">
            <BDataGrid
              ref="TransactionHistoryGrid"
              results={tableData}
              columns={[
                'date',
                'description',
                'type',
                'tag',
                'amount',
                'account',
              ]}
              columnMetadata={columnMeta}
              useCustomPagerComponent="true"
              initialSortAscending={false}
              next={this.onPageChange}
              onSort={this.onSortChange}
              customClick={this.props.onRowClick}
              rowClickIndex={this.props.rowClickIndex}
              initialSort="date"
              enableInfiniteScroll
              useFixedHeader
              bodyHeight={400}
              resultsPerPage={tableData.length}
              content={content}
              rowExpander
              showNoData
              noDataMessage={content.spendingTableLoading1}
              showPager={hasMoreData}
              tableClassName="table"
              isFooterEnabled={isFooterEnabled}
              rowCustomClass={this.props.rowCustomClass}
            />
          </div>
        )}
      </div>
    );
  }
}

TransactionScreenDataGrid.propTypes = {
  content: PropTypes.object,
  onRowClick: PropTypes.func,
  pageSize: PropTypes.number,
};

export { TransactionScreenDataGrid };
